import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'nr-icon',
  imports: [CommonModule],
  templateUrl: './nr-icon.component.html',
})
export class NRIconComponent {
  @Input() sizeClass = '';
  @Input() name;
  @Input() iconId?: string;
  @Input() ariaLabel = '';
  @Input() role = 'button';
  @Output() iconClick = new EventEmitter<Event>();

  onClickIcon(event: Event) {
    this.iconClick.emit(event);
  }
}
